"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[414],{

/***/ 20414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SectionCallToAction": function() { return /* reexport */ SectionCallToAction; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(79570);
// EXTERNAL MODULE: ../../libs/components/src/index.ts + 122 modules
var src = __webpack_require__(75762);
// EXTERNAL MODULE: ../../libs/icons/src/index.ts + 18 modules
var icons_src = __webpack_require__(46115);
// EXTERNAL MODULE: ../../libs/styles/src/index.ts + 15 modules
var styles_src = __webpack_require__(55022);
;// CONCATENATED MODULE: ../../libs/page-builder/src/lib/SectionCallToAction/SectionCallToAction.tsx




const SectionCallToActionContainer = (0,styles_src/* styled */.zo)("div", {
    display: "grid",
    gap: 32,
    gridTemplateColumns: "1fr",
    paddingInline: "20px",
    "@lg": {
        maxWidth: "$containerMaxWidthForCenteredSection",
        marginInline: "auto"
    },
    variants: {
        alignment: {
            stretch: {
                "@lg": {
                    gridTemplateColumns: "1fr 1fr"
                }
            },
            center: {
                "@lg": {
                    gridTemplateColumns: "1fr",
                    justifyItems: "center"
                }
            }
        }
    }
});
const SectionCallToActionTextContent = (0,styles_src/* styled */.zo)("div", {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    justifyContent: "center",
    gap: 32,
    gridRow: 2,
    "@lg": {
        gridRow: 1
    },
    variants: {
        alignment: {
            left: {
                "@lg": {
                    alignItems: "flex-start",
                    textAlign: "left",
                    gap: 24
                }
            },
            center: {
                "@lg": {
                    alignItems: "center",
                    textAlign: "center"
                }
            }
        }
    }
});
const SectionCallToActionTitle = (0,styles_src/* styled */.zo)("h2", {
    color: "$white",
    projectFont: "heading02",
    textWrap: "pretty",
    variants: {
        width: {
            wide: {
                maxWidth: "100%"
            },
            narrow: {
                maxWidth: 440
            }
        }
    }
});
const SectionCallToActionDescription = (0,styles_src/* styled */.zo)("div", {
    color: "$white",
    projectFont: "body03",
    variants: {
        width: {
            wide: {
                maxWidth: 600
            },
            narrow: {
                maxWidth: 440
            }
        }
    }
});
const SectionCallToActionButton = (0,styles_src/* styled */.zo)("div", {});
const LinkLabel = (0,styles_src/* styled */.zo)("span", {
    marginRight: "8px"
});
const MediaWrap = (0,styles_src/* styled */.zo)("div", {
    overflow: "hidden",
    borderRadius: "8px",
    gridRow: 1,
    "@lg": {
        paddingInline: 0
    }
});
const SectionCallToAction = (param)=>{
    let { title , description , ctaLabel , cta , media , priority  } = param;
    const isMediaPresent = (0,src/* isRenderableMediaField */.Z4)(media);
    const textWidth = isMediaPresent ? "narrow" : "wide";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* SectionWrapper */.Uq, {
        type: "MEDIUM",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionCallToActionContainer, {
            alignment: isMediaPresent ? "stretch" : "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionCallToActionTextContent, {
                    alignment: isMediaPresent ? "left" : "center",
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionCallToActionTitle, {
                            as: priority ? "h1" : "h2",
                            width: textWidth,
                            children: title
                        }),
                        description && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionCallToActionDescription, {
                            width: textWidth,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* PortableText */.YI, {
                                value: description,
                                appearance: "plain",
                                disableTopBottomMargins: true
                            })
                        }),
                        cta && ctaLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionCallToActionButton, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src/* Link */.rU, {
                                ...cta,
                                appearance: "containedTransparent",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkLabel, {
                                        children: ctaLabel
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_src/* OpenNewTab */.mw, {})
                                ]
                            })
                        })
                    ]
                }),
                isMediaPresent && (media === null || media === void 0 ? void 0 : media.mediaPayload) && /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaWrap, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Media */.pU, {
                        ...media,
                        priority: priority,
                        layout: "responsive",
                        sizes: "(min-width: 740px) 560px, 90vw",
                        hardcropRatio: "square"
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../libs/page-builder/src/lib/SectionCallToAction/index.ts



/***/ })

}]);